import { ReactNode } from "react";

export type FormGridV2Props = {
  children: ReactNode;
  columns?: 1 | 2;
};

export function FormGridV2({ children, columns = 2 }: FormGridV2Props) {
  return <div className={`ov2-grid ov2-grid--${columns}`}>{children}</div>;
}
